export function normalizeDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  return isNaN(d.getTime()) ? "-" : d.toISOString().slice(0, 10);
}

export function normalizeTime(value) {
  if (!value) return "-";
  return String(value).replace("Z", "").slice(0, 5);
}

export function normalizeSeasonStatus(raw) {
  if (raw == null) return "-";
  const v = String(raw).toLowerCase();
  if (["true", "1", "active"].includes(v)) return "Active";
  if (["false", "0", "inactive"].includes(v)) return "Inactive";
  return String(raw);
}

export const getPlayerFullName = (player) => {
  if (!player) return "";
  const first = player.player_first_name || "";
  const last  = player.player_last_name  || "";
  return `${first} ${last}`.trim();
};

export const getLineupFullName = getPlayerFullName;

export const getEventPlayerName = (player) => {
  if (!player) return "";
  return (
    player.unique_name
    || player.player_last_name
    || ""
  );
};

export const getOfficialName = (official) => {
  if (!official) return "";
  const first = official.official_first_name;
  const last = official.official_last_name;
  if (first && last) {
    return `${first} ${last}`;
  }
  return official.official_short_name || "";
};

export const getStaffName = (staff) => {
  if (!staff) return "";

  const first = staff.staff_first_name;
  const last = staff.staff_last_name;

  if (first && last) {
    return `${first} ${last}`;
  }

  return first || last || "";
};
